import React from 'react';
import PropTypes from 'prop-types';
import TTMetadata from './c/ttMetadata/TTMetadata';
import TTColumnManager from './c/ttColumnManager/TTColumnManagerConnector';
import './translationTable.scss';
import TTRowManager from './c/ttRowManager/TTRowManagerConnector';

class TranslationTable extends React.Component {
  constructor (props){
    super(props);
    if(!props.translationTableEditionMode){
      props.ttActions.createTranslationTable();
    }
  }
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.translationTable.name !== this.props.translationTable.name || prevProps.sourceColumns !== this.props.sourceColumns ||
    prevProps.targetColumn !== this.props.targetColumn){
      this.isSaveButtonEnable();
    }
  }

  handleTTMetadataValueChange = (name, value) => this.props.ttActions.updateTranslationTable(name, value);

  isSaveButtonEnable = () => {
    const isTTWithValues = this.props.translationTable.name !== '' &&
    this.checkSourceColumnsValue(this.props.sourceColumns) &&
    this.checkTargetColumnValue(this.props.targetColumn);

    this.props.isSaveButtonEnable(isTTWithValues);
  };

  checkSourceColumnsValue = sourceColumns => sourceColumns.find(sourceColumn => (sourceColumn.hasOwnProperty('sourceField') && sourceColumn.sourceField !== null)) !== undefined;

  checkTargetColumnValue = targetColumn => targetColumn.hasOwnProperty('sourceField') && targetColumn.sourceField !== null;

  render() {
    const { sourceColumns, targetColumn, translationTable, fetchingTranslationTable, translationTableEditionMode } = this.props;

    return (
      <div className={ 'translation-table__main-container' }>
        {
          translationTable.id && !fetchingTranslationTable &&
          <React.Fragment>
            <TTMetadata 
              name={ translationTable.name } 
              description={ translationTable.description } 
              onValueChange={ this.handleTTMetadataValueChange } 
              disabled={ translationTableEditionMode } 
            />
            <TTColumnManager sourceColumns={ sourceColumns } targetColumn={ targetColumn } translationTableId={ translationTable.id } />
            <TTRowManager sourceColumns={ sourceColumns } targetColumn={ targetColumn } />
          </React.Fragment>
        }
      </div>
    );
  }
}

TranslationTable.propTypes = {
  translationTable: PropTypes.object.isRequired,
  sourceColumns: PropTypes.array.isRequired,
  targetColumn: PropTypes.object,
  translationTableEditionMode: PropTypes.bool,
  fetchingTranslationTable: PropTypes.bool,
  ttActions: PropTypes.shape({
    createTranslationTable: PropTypes.func,
    updateTranslationTable: PropTypes.func,
    fetchTranslationTable: PropTypes.func
  }).isRequired,
  isSaveButtonEnable: PropTypes.func.isRequired
};

export default TranslationTable;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/TranslationTable.js